import React from "react";
import ErrorFeedbackBar from "../../global/ErrorFeedbackBar";
import { STATEMENT_TAXES_PAGES, SOURCE_OPTIONS_TAXES } from "./constants";
import FeedbackBar from "../../feedbackBar/FeedbackBar";
import withShipment from "../../../withShipment";
import {
    loadingSelector,
    paidListSelector,
    receivedListSelector,
    statementTaxesSummarySelector, statementTaxesTemplateSelector,
    transactionCategoriesSelector, transactionSelector
} from "../../../redux/selectors/accounting";
import {statusSelector} from "../../../redux/selectors/global";
import {clearStatus} from "../../../redux/actions/global";
import {userInfoSelector} from "../../../redux/selectors/auth";
import StatementTaxesTable from "./StatementTaxesTable";
import StatementTaxesTemplate from "./StatementTaxesTemplate";
import StatementTaxesAuditPreviewDialog from "./preview/StatementTaxesAuditPreviewDialog";
import { buildStatementTaxesDiff } from "./preview/statementTaxesDiff";
import {
    listAllTransactions,
    listStatementTaxes, listStatementTaxesTemplate, previewStatementTaxes,
    listTransactionCategories,
    saveStatementTaxesTemplate
} from "../../../redux/actions/accounting";
import {tableSettingSelector} from "../../../redux/selectors/account";
import {getTableSetting, saveTableSetting} from "../../../redux/actions/account";

class StatementTaxes extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            transactionCategories:this.props.transactionCategories,
            currentPage: STATEMENT_TAXES_PAGES.TABLE,
            feedbackBarOpen: false,
            error: false,
            selectedYear: new Date().getFullYear(),
            selectedCurrency: 'CAD',
            selectedMonth: ' ',
            selectedQuarters: null,
            totalSum: 0,
            statementTaxesSummaryFilterSetting: null,
            isRefresh: false,
            isAuditPreviewOpen: false,
            previewSummary: null,
            previewOldSummary: null,

    }
    }


    componentDidMount() {
        this.props.getTableSetting(this.props.user.userId)
        this.props.listTransactionCategories()
        this.props.listStatementTaxesTemplate()
        this.props.listAllTransactions()
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.status.statusText && prevProps.status.statusText !== this.props.status.statusText){
            this.openFeedbackBar()
        }

        if (prevProps.tableSetting !== this.props.tableSetting) {
            this.setState({ statementTaxesSummaryFilterSetting: this.props.tableSetting?.statementTaxesSummaryFilterSetting },()=>{
                this.setState({
                    selectedCurrency: this.state.statementTaxesSummaryFilterSetting.currency,
                    selectedYear: this.state.statementTaxesSummaryFilterSetting.year,
                    selectedMonth: this.state.statementTaxesSummaryFilterSetting.month,
                    selectedQuarters: this.state.statementTaxesSummaryFilterSetting.quarters,
                },()=>{
                    this.listStatementTaxesAPI()
                })
            })
        }

        //update state transactionCategories
        if (prevProps.transactionCategories !== this.props.transactionCategories) {
            this.setState({
                transactionCategories : this.props.transactionCategories
            })
        }
        //sort state transactionCategories by displayOrder
        if (prevState.transactionCategories !== this.state.transactionCategories) {
            this.setState({
                transactionCategories : this.state.transactionCategories.sort((a, b) => a.displayOrder - b.displayOrder)
            })
        }


    }

    handleSave = (templates) => {
        this.props.saveStatementTaxesTemplate(templates, ()=>{
            this.listStatementTaxesAPI()
        })
        this.setCurrentPage(STATEMENT_TAXES_PAGES.TABLE, {})
    }

    listStatementTaxesAPI = () =>{
        let data
        if(this.state.selectedQuarters === null){
            data = {
                "year": this.state.selectedYear,
                "quarter": [1,2,3,4],
                "currency": this.state.selectedCurrency,
                "month": this.state.selectedMonth.trim(),
                "isRefresh": this.state.isRefresh,
            }
        }else{
            let newQuarter = [this.state.selectedQuarters]
            data = {
                "year": this.state.selectedYear,
                "quarter": newQuarter,
                "currency": this.state.selectedCurrency,
                "month": this.state.selectedMonth.trim(),
                "isRefresh": this.state.isRefresh,
            }
        }
        this.props.listStatementTaxes(data)
        this.setState({isRefresh: false})
    }

    setFetch = (bool)=>{
        this.setState({isRefresh: bool},()=>{
            this.listStatementTaxesAPI()
        })

    }

    // Filter payload shared by the list and the preview recompute.
    buildStatementTaxesQuery = () => {
        const quarter = this.state.selectedQuarters === null
            ? [1, 2, 3, 4]
            : [this.state.selectedQuarters]
        return {
            year: this.state.selectedYear,
            quarter,
            currency: this.state.selectedCurrency,
            month: this.state.selectedMonth.trim(),
        }
    }

    // The sources this statement is built from, derived from the saved template mapping (e.g.
    // Transactions, Marketplace Summary, Shipping Summary, Purchase Summary), in canonical order.
    getLinkedSources = () => {
        const templates = Array.isArray(this.props.templates) ? this.props.templates : []
        const used = new Set(templates.map(t => t && t.source).filter(Boolean))
        return SOURCE_OPTIONS_TAXES.filter(source => used.has(source))
    }

    // Refresh entry point: capture the currently displayed rows as the "before" baseline, fetch a
    // non-persisting recompute and open the audit preview. Nothing is committed until Apply.
    handleOpenAuditPreview = () => {
        const previewOldSummary = {
            paidList: Array.isArray(this.props.paidList) ? [...this.props.paidList] : [],
            receivedList: Array.isArray(this.props.receivedList) ? [...this.props.receivedList] : [],
        }
        this.setState({ isAuditPreviewOpen: true, previewSummary: null, previewOldSummary })
        this.props.previewStatementTaxes(this.buildStatementTaxesQuery(), (error, taxSummary) => {
            if (!error && taxSummary) {
                this.setState({ previewSummary: taxSummary })
            } else {
                this.setState({ isAuditPreviewOpen: false, previewOldSummary: null })
            }
        })
    }

    // Apply = run the real (persisting) refresh, which recomputes, saves the linked summaries and
    // repaints the statement.
    handleApplyPreview = () => {
        this.setState({ isAuditPreviewOpen: false, previewSummary: null, previewOldSummary: null }, () => {
            this.setFetch(true)
        })
    }

    handleCancelPreview = () => {
        this.setState({ isAuditPreviewOpen: false, previewSummary: null, previewOldSummary: null })
    }

    buildPreviewData = () => {
        const previewLoading = this.state.isAuditPreviewOpen && !this.state.previewSummary
        const diff = (this.state.isAuditPreviewOpen && this.state.previewSummary)
            ? buildStatementTaxesDiff(this.state.previewOldSummary || {}, this.state.previewSummary)
            : null
        return { previewLoading, diff }
    }

    handleYearChange = (event) => {
        this.setState({ selectedYear: event.target.value },() => {
            this.onFiltersInputChange("year",event)
        })

    }

    handleMonthChange = (event) => {
        this.setState({ selectedMonth: event.target.value },() => {
            this.onFiltersInputChange("month",event)
        })

    }

    handleCurrencyChange = (event) => {
        this.setState({ selectedCurrency: event.target.value },() => {
            this.onFiltersInputChange("currency",event)
        })
    }


    handleQuarterChange = (quarter) => {
        const quarterMapping = {
            "QTR 1": 1,
            "QTR 2": 2,
            "QTR 3": 3,
            "QTR 4": 4
        }
        const quarterNumber = quarterMapping[quarter]
        const selectedQuarters = this.state.selectedQuarters === quarterNumber ? null : quarterNumber
        this.setState({ selectedQuarters }, () => {
            this.onFiltersInputChange("quarters",this.state.selectedQuarters)
        })
    }


    setCurrentPage = (newPage) => {
        this.setState({
            currentPage: newPage
        })
    }

    displayTable = () => {
            return (
                <StatementTaxesTable
                    setFetch={this.setFetch}
                    onRefresh={this.handleOpenAuditPreview}
                    loadingData={this.props.loadingData}
                    selectedQuarters={this.state.selectedQuarters}
                    selectedYear={this.state.selectedYear}
                    handleQuarterChange={this.handleQuarterChange}
                    handleYearChange={this.handleYearChange}
                    selectedCurrency={this.state.selectedCurrency}
                    handleCurrencyChange={this.handleCurrencyChange}
                    selectedMonth={this.state.selectedMonth}
                    handleMonthChange={this.handleMonthChange}
                    paidList={this.props.paidList}
                    receivedList={this.props.receivedList}
                    totalSum={this.state.totalSum}
                    setCurrentPage={this.setCurrentPage}
                    openFeedbackBar={this.openFeedbackBar}
                    listStatementTaxes={this.props.listStatementTaxes}
                />
            )
    }

    displaySettings = () => {
        return (
            <StatementTaxesTemplate
                handleSave={this.handleSave}
                categories={this.state.transactionCategories}
                templates={this.props.templates}
                setCurrentPage={this.setCurrentPage}
                openFeedbackBar={this.openFeedbackBar}
                transactions={this.props.transactions}
            />
        )

    }


    displayCurrentPage = () => {
        switch (this.state.currentPage) {
            case STATEMENT_TAXES_PAGES.TABLE:
                return this.displayTable()
            case STATEMENT_TAXES_PAGES.SETTINGS:
                return this.displaySettings()
            default:
                return <div>We encountered an error. Please refresh the page.</div>
        }
    }

    openFeedbackBar = () => {
        this.setState({feedbackBarOpen: true})
    }

    closeFeedbackBar = () => {
        this.setState({ feedbackBarOpen: false }, () => {
            this.props.clearStatus()
        })
    }

    onFiltersInputChange = (name,event) => {
        let filtersMap = this.props.tableSetting?.statementTaxesSummaryFilterSetting

        if(name === "quarters"){
            filtersMap[name] = event;
        }else{
            filtersMap[name] = event.target.value;
        }

        this.saveUpdatedFilters(filtersMap)
    }


    saveUpdatedFilters = (filters) => {
        this.props.saveTableSetting({
            userId: this.props.user.userId,
            tableSetting: null,
            changeFilters: false,
            changeStatementTaxesSummaryFilters: true,
            statementTaxesSummaryFilters: filters
        })
    }

    render() {
        const { previewLoading, diff } = this.buildPreviewData()
        return (
            <React.Fragment>
                <ErrorFeedbackBar/>
                <StatementTaxesAuditPreviewDialog
                    open={this.state.isAuditPreviewOpen}
                    loading={previewLoading}
                    diff={diff}
                    linkedSources={this.getLinkedSources()}
                    onApply={this.handleApplyPreview}
                    onCancel={this.handleCancelPreview}
                />
                <FeedbackBar
                    open={this.state.feedbackBarOpen}
                    handleClose={this.closeFeedbackBar}
                    severity={this.props.status?.success ? 'success' : 'error'}
                    message={this.props.status?.statusText}
                />
                {this.displayCurrentPage()}
            </React.Fragment>
        )
    }
}


const mapStateToProps = (state) => ({
    status: statusSelector(state),
    transactionCategories: transactionCategoriesSelector(state),
    user: userInfoSelector(state),
    receivedList: receivedListSelector(state),
    paidList: paidListSelector(state),
    templates: statementTaxesTemplateSelector(state),
    transactions: transactionSelector(state),
    loadingData: loadingSelector(state),
    tableSetting: tableSettingSelector(state),
})


const actionCreators = {
    clearStatus,
    listAllTransactions,
    listTransactionCategories,
    listStatementTaxes,
    previewStatementTaxes,
    saveStatementTaxesTemplate,
    listStatementTaxesTemplate,
    saveTableSetting,
    getTableSetting,
}

export default withShipment({
    actionCreators,
    mapStateToProps
}, StatementTaxes);